<div class="style-1">
  <div mat-dialog-title>
    <h1 style="margin: 0;display:inline-block;">
      <span>Accesso richiesto</span>
    </h1>
    <span class="material-icons-outlined dialog-close-icon" style="float:right;"
    (click)='onCloseClick()'>close</span>
  </div>
  <mat-dialog-content>
    @if (loading) {
      <mat-progress-bar class='mt-24 mb-24' style='width: 100%' mode="indeterminate"></mat-progress-bar>
    }
    <div class="fx-column fx-justify-space-between fx-items-center">
      <div class="fx-flex">
        <form-input-viewer
          [formInputDefinition]='formFields.get("name")'
          [formGroup]='formViewerService.formGroup'
          [formControlKey]='formViewerService.controlKeyMap["name"]'
          [dataContainerService]='datasetACS'
        ></form-input-viewer>
      </div>
      <div class="fx-flex">
        <form-input-viewer
          [formInputDefinition]='formFields.get("surname")'
          [formGroup]='formViewerService.formGroup'
          [formControlKey]='formViewerService.controlKeyMap["surname"]'
          [dataContainerService]='datasetACS'
        ></form-input-viewer>
      </div>
      <div class="fx-flex">
        <form-input-viewer
          [formInputDefinition]='formFields.get("cartafreccia")'
          [formGroup]='formViewerService.formGroup'
          [formControlKey]='formViewerService.controlKeyMap["cartafreccia"]'
          [dataContainerService]='datasetACS'
        ></form-input-viewer>
      </div>
      <button mat-raised-button (click)="login()" [disabled]="!formViewerService.formGroup.valid">Accedi</button>
      @if (error) {
        <div class="alert-danger">{{error.message}}</div>
      }
    </div>
  </mat-dialog-content>
</div>